/* eslint-disable unicorn/filename-case -- TODO rename later */
import { createContext, useMemo } from "react";

import { useMyMemberships } from "../external-api/profile";
import { checkIsCustomerAdmin } from "../permissions";

export const UserMembershipContext = createContext<{
  isCustomerAdmin: boolean;
  isLoadingMemberships: boolean;
}>({ isCustomerAdmin: false, isLoadingMemberships: true });

function UserMembershipProvider({ children }: { children: React.ReactNode }) {
  const { data: membershipData, isLoading: isLoadingMemberships } = useMyMemberships();

  const value = useMemo(
    () => ({
      isCustomerAdmin: checkIsCustomerAdmin(membershipData),
      isLoadingMemberships,
    }),
    [membershipData, isLoadingMemberships],
  );

  return <UserMembershipContext.Provider value={value}>{children}</UserMembershipContext.Provider>;
}

export default UserMembershipProvider;
